// extracted by mini-css-extract-plugin
export var aboveInput = "_hu-0";
export var actionButton = "_hu-5";
export var actionButtonContainer = "_hu-1";
export var actionIcon = "_hu-6";
export var aiInfoContainer = "_hu-2";
export var attachmentWrapper = "_hu-7";
export var bold = "_hu-3";
export var checkIcon = "_hu-8";
export var clickingRecipientBar = "_hu-11";
export var commentThreadSwitch = "_hu-a";
export var draftImage = "_hu-b";
export var draftImageContainer = "_hu-c";
export var draftImages = "_hu-e";
export var editButton = "_hu-g";
export var editor = "_hu-f";
export var editorContainer = "_hu-y";
export var editorErrorTooltipWrapper = "_hu-9";
export var headerDivider = "_hu-h";
export var icon = "_hu-i";
export var info = "_hu-j";
export var internal = "_hu-n";
export var internalDivider = "_hu-k";
export var internalMessage = "_hu-l";
export var messageInputCard = "_hu-m";
export var messageInputForm = "_hu-o";
export var messageInputFormInternal = "_hu-p";
export var options = "_hu-q";
export var publicMessageCustomer = "_hu-s";
export var publicMessageMerchant = "_hu-r";
export var removeImageButton = "_hu-d";
export var replyButtons = "_hu-t";
export var showSignatureButton = "_hu-u";
export var spinner = "_hu-v";
export var verticalButtonDivider = "_hu-4";
export var visibilitySelector = "_hu-w";
export var warning = "_hu-x";
export var wrappingText = "_hu-z";
export var writingInternalNoteTopBorder = "_hu-10";